import { render, staticRenderFns } from "./BookmarkedCandidates.vue?vue&type=template&id=a19a4e20&"
import script from "./BookmarkedCandidates.vue?vue&type=script&lang=js&"
export * from "./BookmarkedCandidates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports